import { Dispatch } from "react";

import { emptyDoughnutStyles } from "../../config";

export const cutout = 50;
export const diameter = "142";

export const options: any = (
  _data: any,
  setHoveredElement: Dispatch<any>,
  handleElementClick: (element: Element) => void
) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    onClick: function (_event: any, activeElements: Element[]) {
      handleElementClick(activeElements[0]);
    },
    onHover: function (_event: any, activeElements: any) {
      if (activeElements.length > 0) {
        setHoveredElement(activeElements[0].index);
      }
    },
    plugins: {
      tooltip: {
        // disable default tooltip
        enabled: false
      },
      legend: {
        display: false
      },
      emptyDoughnut: emptyDoughnutStyles(cutout)
    },
    cutout: cutout
  };
};
